import defaultAxios from "lib/http/http.common"
import {ApiResponse} from "api/common/response"
import {Environment} from "dto/env/env"

const findEnvironment = async () => {
    const response = await defaultAxios.get<ApiResponse<Environment>>('/env')
    return response?.data || {}
}

const updateEnvironment = async (env: Environment) => {
    await defaultAxios.post(`/env`, env)
}

export const EnvApi = {
    findEnvironment,
    updateEnvironment,
}
